import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";

import TopBarConsumer from "../ui/TopBarConsumer";
import TopBarManager from "../ui/TopBarManager";
import { useBmapi } from "../utils/bmapi-context";
import { LINK_TYPE } from "../utils/constants";

function isAction(link) {
  return link.menu?.position === LINK_TYPE.ACTION;
}

function isPage(link) {
  return (
    (link.menu && !link.menu.position) || link.menu?.position === LINK_TYPE.PAGE
  );
}

export default function Navbar() {
  const { bmapi, pages } = useBmapi();
  const history = useHistory();
  const { business } = bmapi.getUserInfo();

  const TopBar = useMemo(
    () => (bmapi.isConsumer() ? TopBarConsumer : TopBarManager),
    [bmapi]
  );

  function setActive(link) {
    return {
      ...link.menu,
      url: link.menu.url || link.routing?.path.replace(/:([\w?]+)\/$/g, ""),
      active: link.menu.url === history.location.pathname,
    };
  }

  return (
    <TopBar
      links={pages.filter(isPage).map(setActive)}
      logo={business?.logo || bmapi.logo({ small: true })}
      actions={pages.filter(isAction).map(setActive)}
    />
  );
}
